// import store from '@/store/index'
// import router from '@/router/index'
import { Message } from 'element-ui';

export default {
    $$message:(msg='操作成功',type='success')=>{
        Message.closeAll();
        // eslint-disable-next-line new-cap
        Message({
            message:msg,
            showClose: true,
            type:type,
            duration: 3 * 1000
        })
    }
}